export default function BtnHome() {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250.000000 250.000000" preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,250.000000) scale(0.100000,-0.100000)" stroke="none">
                <path d="M1169 2398 c-41 -46 -115 -128 -163 -183 -49 -55 -106 -118 -125
                    -140 -20 -22 -183 -204 -361 -405 -405 -455 -383 -431 -459 -511 -34 -37 -60
                    -72 -56 -78 4 -7 59 -10 153 -9 l147 2 3 -522 2 -522 389 0 c344 0 390 2 395
                    16 3 8 6 165 5 347 l-1 332 146 3 146 3 0 -351 0 -350 395 0 395 0 0 520 c0
                    409 3 520 13 520 6 1 73 1 149 0 85 -1 139 3 143 9 4 8 -509 601 -555 641 -4
                    3 -100 111 -215 240 -387 435 -459 515 -465 518 -4 1 -40 -35 -81 -80z"/>
            </g>
        </svg>
    );
}